let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eQT38")).then(() => parcelRequire('5c5SM'));